var avatar = 'olp0180 _1uyghc9p';
var initial = {sm:'_1uyghc9k _14wijgrc',md:'_1uyghc9k _14wijgr7',lg:'_1uyghc9k _14wijgr7',xlg:'_1uyghc9k _14wijgr4'};

export { avatar, initial };
//# sourceMappingURL=avatar.css.js.map
